import React from 'react'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './UserSummary.scss'


type StatsType = {
  reviewsTotal: number
  likeTotal: number
  dislikeTotal: number
  shippedCount: number
}

export type UserSummaryProps = {
  url: string
  stats: StatsType,
}


const UserSummary: React.FunctionComponent<UserSummaryProps> = (props) => {
  const { url, stats: { reviewsTotal, likeTotal, dislikeTotal, shippedCount } } = props

  const reviewsUrl   = `${url}?reviews`
  const deliveredUrl = `${url}?delivered`

  return (
    <div className={s.summary}>
      <Link className={s.summaryLink} toOLD={reviewsUrl} customColor>
        <FormattedHTMLMessage tag="div" {...messages.reviews} values={{ reviewsTotal }} />
      </Link>
      <FormattedHTMLMessage tag="div" {...messages.likes} values={{ likeTotal }} />
      <FormattedHTMLMessage tag="div" {...messages.dislikes} values={{ dislikeTotal }} />
      <Link className={s.summaryLink} toOLD={deliveredUrl} customColor>
        <FormattedHTMLMessage tag="div" {...messages.productsReceived} values={{ shippedCount }} />
      </Link>
    </div>
  )
}


export default UserSummary
